import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 0 auto;
  flex: 1;
  width: 100%;
  max-width: 1350px;
  padding-block: 20px;

  .title {
    margin-bottom: 30px;
  }
  .ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) {
    &:hover {
      .ant-select-selector {
          border-color: ${({ theme }) => theme.success};
        }
      }
  }

  .ant-select-focused.ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) {
    .ant-select-selector {
      border-color: ${({ theme }) => theme.success};
      box-shadow: 0 0 0 2px ${({ theme }) => theme.success}20;
    }

    &:hover {
      border-color: ${({ theme }) => theme.success};
    }
  }
`

export const Heading = styled.h1`
  font-weight: 600;
  font-size: 24px;
`

export const Filter = styled.div`
    .ant-row {
      + .ant-row {
        margin-top: 8px;
      }
    }

    .label {
      display: flex;
      justify-content: end;
      align-items: center;
      height: 100%;
    }
`
